import React from 'react';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import Routes from '../../Shared/routes';
import Department from '../../Entities/Department';
import Channel from '../../Entities/Channel';


interface IProps {
    channel?: Channel;
    list: Department[];
    error: string;
    remove: (departmentId: number) => void;
    add: () => void;
    isLoading: boolean;
}

export default class DepartmentList extends React.Component<IProps> {

    onAddSource = () => {
        this.props.add();
    }

    renderItem = (item: Department) => {
        return (
            <tr>
                <td>{item.getId()}</td>
                <td>{item.name}</td>
                <td>
                    <Link to={`${Routes.DEPARTMENT_EDIT}${this.props.channel?.getId()}/${item.getId()}`}>Редактировать</Link><br />
                    <a href="#" onClick={() => this.props.remove(item.getId())}>Удалить</a>
                </td>
            </tr>
        )
    }

    render() {
        const { isLoading, list, channel } = this.props;
        if (isLoading) {
            return <Loading />;
        }
        else {
            return (
                <>

                    <div className="app-title">
                        <div>
                            <h1><i className="fa fa-th-list"></i> Отделы канала {channel?.name}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="tile">
                                <button
                                    onClick={this.onAddSource}
                                    className="btn btn-primary"
                                    type="submit">Добавить отдел к каналу</button>
                                <br />
                                <br />
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Название</th>
                                            <th>Действия</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(this.renderItem)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}